import { PulseBaseProvider } from '../../../../base-classes';
import { IStationObservationsData } from "../../../types/APIResponses/WeatherStationObservations/WeatherStationObservationsResponses";
import {
    IGetStationObservationsParams
} from "../../../actions/WeatherStationObservations/SelectedStation/selectedStationObservationsAction";
import { IPulseRequestConfiguration } from "../../../types/PulseInterfaces";

const _allStationObservationCacheKey = 'allStationObservationSummary';
const _allStationObservationUri = '/api/obs/surface/current/v6';

export class allStationObservationProvider extends PulseBaseProvider {
  constructor(baseUrl: string, authId: string, secret: string, options=undefined, logger=undefined) {
      super(baseUrl, authId, secret, options, logger);
      this.storage.sync[_allStationObservationCacheKey] = this.allStationObservationSyncer.bind(this);   
  }

  async allStationObservationSyncer(params: any): Promise<IStationObservationsData> {
        const { id, syncParams, resolve, reject } = params;
   
        const queryParams = {
            ...syncParams.stdParameters,
            cachedOnly: syncParams.isCached,
            directionUnit: syncParams.directionUnit,
            disableRollover: syncParams.disableRollover,
            distanceUnit: syncParams.distanceUnit,
            fml: syncParams.fml,
            pageNumber: syncParams.pageNumber,
            pageSize: syncParams.pageSize,
            precipitationRateUnit: syncParams.precipitationRateUnit,
            precipitationUnit: syncParams.precipitationUnit,
            pressureUnit: syncParams.pressureUnit,
            roundingProfile: syncParams.roundingProfile,
            searchRadius: syncParams.searchRadius,
            speedUnit: syncParams.speedUnit,
            stationState: syncParams.stationState,
            stationType: syncParams.stationType,
            temperatureUnit: syncParams.temperatureUnit,
            verbose: syncParams.verbose,
        };

        let apiPath = `${_allStationObservationUri}/locationType=latitudelongitude/location=${syncParams.latitude},${syncParams.longitude}`;

        return await super.syncData(syncParams.key, id, queryParams, apiPath, resolve, reject, null, syncParams.pulseApi);
    }

    async getAllStationObservationData({ apiParameters, requestConfiguration }: {
        apiParameters: IGetStationObservationsParams,
        requestConfiguration: IPulseRequestConfiguration
    }): Promise<IStationObservationsData> {   
        const id = JSON.stringify({ ...apiParameters, ...requestConfiguration });

        if (requestConfiguration.forceRefreshOfCachedData) {
            super.removeFromStorage(_allStationObservationCacheKey, id);
        }
        
        return await super.loadFromStorage(_allStationObservationCacheKey, id, apiParameters);
    }
}
